import { Directive, ElementRef, inject, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: 'span[pdsSpoiler], div[pdsSpoiler]',
  standalone: false,
})
export class PDSSpoilerDirective implements OnInit {
  elementRef = inject(ElementRef);
  renderer = inject(Renderer2);

  get hostElement() {
    return this.elementRef.nativeElement as HTMLElement;
  }

  get currentText() {
    return this.hostElement.innerText;
  }

  ngOnInit() {
    this.renderer.addClass(this.hostElement, 'pds-spoiler');
  }
}
